import { BACKEND_URL, JWT_KEY } from '../config';
import { getWithExpiry } from './localStorageService';

export const getPaidForCustomerIds = async (year) => {
  const response = await fetch(`${BACKEND_URL}api/v1/orders?year=${year}`, {
    mode: 'cors',
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${getWithExpiry(JWT_KEY)}`,
    },
  }).catch((err) => {
    console.error('Get Orders call failed:', err);
  });

  if (!response.ok) {
    console.log('Get Orders call failed: ', response);
    return;
  }

  const orders = await response.json();
  return orders.map(({ toCustomerId }) => toCustomerId);
};

export const getOrdersByYear = async (year) => {
  if (!year) return [];
  const response = await fetch(`${BACKEND_URL}api/v1/orders?year=${year}`, {
    mode: 'cors',
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${getWithExpiry(JWT_KEY)}`,
    },
  }).catch((err) => {
    console.error('Get Orders by year call failed:', err);
  });

  if (!response || !response.ok) {
    console.log('Get Orders by year call failed: ', response);
    return [];
  }

  const orders = await response.json();
  return orders;
};

export const getOrderYears = async () => {
  const response = await fetch(`${BACKEND_URL}api/v1/orders/admin/years`, {
    mode: 'cors',
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${getWithExpiry(JWT_KEY)}`,
    },
  }).catch((err) => {
    console.error('Get order years failed:', err);
  });

  if (!response || !response.ok) {
    console.log('Get order years failed: ', response);
    return [];
  }

  const years = await response.json();
  return Array.isArray(years) ? years : [];
};